export const isTariffRedirectDisabled = (activeStorage: string | null | undefined, isStorageOnline: boolean | undefined): boolean =>
  !activeStorage || !isStorageOnline
